import { createAction } from '@reduxjs/toolkit';

import {
    UPDATE_DIRECT_DEPOSIT_STEPS,
    UPDATE_EMPLOYER_AND_AMOUNT_STEP,
} from '@perpay-web/fintech/constants/steps/updateDirectDepositSteps';
import { useActionObservableCallback } from '@perpay-web/hooks/useActionObservableCallback';
import { useSteps } from '@perpay-web/hooks/useSteps';
import { hookAction$ } from '@perpay-web/services/singletons';
import { createContextProvider } from '@perpay-web/utils/componentUtils';

export const updateDirectDepositStepsSetStep = createAction(
    'UPDATE_DIRECT_DEPOSIT_STEPS::SET_STEP',
);

export const updateDirectDepositStepsReset = createAction(
    'UPDATE_DIRECT_DEPOSIT_STEPS::RESET',
);

const useUpdateDirectDepositSteps = ({ initialStepForStorybook }) => {
    const hook = useSteps(
        UPDATE_DIRECT_DEPOSIT_STEPS,
        initialStepForStorybook || UPDATE_EMPLOYER_AND_AMOUNT_STEP,
    );

    return hook;
};

const providerFactory = (Context) => {
    const Provider = ({ initialStepForStorybook, children }) => {
        const hook = useUpdateDirectDepositSteps({ initialStepForStorybook });

        useActionObservableCallback(
            hookAction$,
            updateDirectDepositStepsSetStep().type,
            (step) => hook.setStep(step),
        );

        useActionObservableCallback(
            hookAction$,
            updateDirectDepositStepsReset().type,
            (initialStep) => hook.reset(initialStep),
        );

        return <Context.Provider value={hook}>{children}</Context.Provider>;
    };

    return Provider;
};

export const [
    UpdateDirectDepositStepsProvider,
    useUpdateDirectDepositStepsContext,
] = createContextProvider(providerFactory);
